import { AvField, AvForm } from "availity-reactstrap-validation"
import MetaTag from "components/Common/Meta-tag"
import { debounce, map, range } from "lodash"
import moment from "moment"
import MyPagination from "components/Common/MyPagination"
import React, { useEffect, useState } from "react"
import BootstrapTable from "react-bootstrap-table-next"
import ToolkitProvider from "react-bootstrap-table2-toolkit"
import { useDispatch, useSelector } from "react-redux"
import { Link } from "react-router-dom"
import { Badge, Card, CardBody, Col, Container, Row, Spinner } from "reactstrap"
import { getEarnings } from "store/actions"
import Breadcrumbs from "../../../components/Common/Breadcrumb"

function AllEarnings() {
  const dispatch = useDispatch()
  const [finalDateFormated, setFinalDateFormated] = useState({
    from: "",
    to: "",
  })
  const [page, setPage] = useState(1)
  const [SearchText, setOrderSearchText] = useState("")
  const [ItemLimit, setTotalItemLimit] = useState(10)

  const { loading, AllEarnings, total } = useSelector(state => ({
    loading: state.Users.loading,
    AllEarnings: state.Users.earnings,
    total: state?.Users?.earnings?.total,
  }))

  const totalPages = Math.ceil(total / 10)
  const pages = range(1, totalPages + 1)

  const handleDateSearch = () => {
    if (
      finalDateFormated?.from?.length >= 1 &&
      finalDateFormated?.to?.length >= 1
    ) {
      return finalDateFormated
    } else {
      return {
        from: "",
        to: "",
      }
    }
  }
  const debounceOrderSearch = debounce(value => setOrderSearchText(value), 600)

  const columns = [
    {
      dataField: "createdAt",
      text: " Date",
      sort: true,
    },
    {
      dataField: "orderId",
      text: "Order Id",
      sort: true,
    },
    {
      dataField: "orderAmount",
      text: "Order Amount",
      sort: true,
    },
    {
      dataField: "orderStatus",
      text: "Status",
      sort: true,
    },
    {
      dataField: "name",
      text: "Promoter",
      sort: true,
    },
    {
      dataField: "amount",
      text: "Amount",
      sort: true,
    },
    {
      dataField: "ref_id",
      text: "Refferal ID",
      sort: true,
    },
  ]

  const handleOrderStatus = status => {
    switch (status) {
      case "Processing":
        return "info"
      case "Shipped":
        return "info"
      case "Delivered":
        return "success"
      case "Cancelled":
        return "warning"
      case "Returned":
        return "danger"
      case "Fulfilled":
        return "success"
      case "Partially Fulfilled":
        return "success"
      default:
        return "info"
    }
  }

  const earnings = map(AllEarnings?.earnings, (item, index) => ({
    ...item,
    createdAt: (
      <span>
        <h6>{moment(item?.createdAt).format("DD/MM/YYYY h:mm A")}</h6>
      </span>
    ),
    orderId: (
      <span>
        <Link to={`/order/${item?.order?._id}`}>
          <h6 className="text-primary">{item?.order?.orderId}</h6>
        </Link>
      </span>
    ),
    orderAmount: (
      <span>
        <h6>{item?.orderAmount ? item?.orderAmount : "0.00"}</h6>
      </span>
    ),
    orderStatus: (
      <span>
        <h6 className="font-size-14">
          <Badge
            className={
              "px-2 py-2 badge-soft-" +
              `${handleOrderStatus(item?.order?.orderStatus)}`
            }
          >
            {item?.order?.orderStatus}
          </Badge>
        </h6>
      </span>
    ),
    name: (
      <span>
        <h6>{item?.promoter?.name}</h6>
      </span>
    ),

    amount: (
      <span>
        <h6>{item?.promoterAmount}</h6>
      </span>
    ),
    ref_id: (
      <span>
        <h6 className="text-primary">{item?.ref_id}</h6>
      </span>
    ),
  }))
  useEffect(() => {
    dispatch(getEarnings(page, ItemLimit, SearchText, handleDateSearch()))
  }, [dispatch, page, SearchText, ItemLimit, finalDateFormated])

  const handleTableChange = (type, { page, searchText }) => {
    setShopList(
      zshops.filter(zshop =>
        Object.keys(zshop).some(key =>
          zshop[key].toLowerCase().includes(searchText.toLowerCase())
        )
      )
    )
  }
  const listChange = sortValue => {
    setSort(sortValue)
  }
  const handlePageLimit = e => {
    if (e.target.value >= 1) {
      setTotalItemLimit(e.target.value)
    }
  }

  return (
    <div>
      <MetaTag title={"All Rewards"} />
      <div className="page-content">
        <Breadcrumbs title="Promoters" breadcrumbItem="All Rewards" />
        <Container fluid>
          <div className="container-fluid">
            <Row>
              <Col className="col-12">
                <Card className="pt-3">
                  <CardBody>
                    <ToolkitProvider
                      keyField="_id"
                      columns={columns}
                      data={earnings}
                      search
                    >
                      {toolkitProps => (
                        <React.Fragment>
                          <Row className="mb-2">
                            <></>
                            <Col className="col-12 d-flex align-items-center mb-3">
                              <div className="search-box ms-2 d-inline-block">
                                <div className="position-relative">
                                  <AvForm>
                                    <AvField
                                      name="searchText"
                                      placeholder="Search"
                                      type="text"
                                      onChange={e =>
                                        debounceOrderSearch(e.target.value)
                                      }
                                    />
                                  </AvForm>
                                  <i className="bx bx-search-alt search-icon" />
                                </div>
                              </div>

                              <AvForm className="form-horizontal mx-3 d-flex align-items-center">
                                <div className="mx-1">
                                  <span className="">
                                    Show
                                    <i className="fas fa-sort-numeric-down-alt mx-1"></i>
                                  </span>
                                </div>
                                <div className="" style={{ width: "50px" }}>
                                  <AvField
                                    name="pageLimit"
                                    className="form-control"
                                    value={ItemLimit}
                                    onChange={e => handlePageLimit(e)}
                                    type="text"
                                    required
                                  />
                                </div>
                              </AvForm>
                              <div className=" d-flex align-items-center ">
                                <p
                                  className="mb-0 pb-0 mx-2"
                                  style={{ whiteSpace: "nowrap" }}
                                >
                                  Sort By Date :
                                </p>
                                <AvForm>
                                  <div className="d-flex date_wrapper">
                                    <div className="d-flex align-items-start position-relative">
                                      <AvField
                                        name="dateRange"
                                        type="date"
                                        validate={{
                                          dateRange: {
                                            start: {
                                              value: -5,
                                              units: "years",
                                            },
                                            end: { value: 5, units: "years" },
                                          },
                                        }}
                                        onChange={e =>
                                          setFinalDateFormated({
                                            ...finalDateFormated,
                                            from: e.target.value,
                                          })
                                        }
                                        value={finalDateFormated?.from}
                                      />
                                      <button
                                        onClick={() =>
                                          setFinalDateFormated({
                                            ...finalDateFormated,
                                            from: "",
                                          })
                                        }
                                        type="button"
                                        className="btn btn-white editable-cancel date_close btn-sm"
                                      >
                                        <i className="mdi mdi-close text-danger "></i>
                                      </button>
                                    </div>
                                    <div className="d-flex align-items-start position-relative">
                                      <AvField
                                        name="dateRange"
                                        className="mx-1"
                                        type="date"
                                        validate={{
                                          dateRange: {
                                            start: {
                                              value: -5,
                                              units: "years",
                                            },
                                            end: { value: 5, units: "years" },
                                          },
                                        }}
                                        onChange={e =>
                                          setFinalDateFormated({
                                            ...finalDateFormated,
                                            to: e.target.value,
                                          })
                                        }
                                        value={finalDateFormated?.to}
                                      />
                                      <button
                                        onClick={() =>
                                          setFinalDateFormated({
                                            ...finalDateFormated,
                                            to: "",
                                          })
                                        }
                                        type="button"
                                        className="btn btn-white editable-cancel date_close btn-sm"
                                      >
                                        <i className="mdi mdi-close text-danger "></i>
                                      </button>
                                    </div>
                                  </div>
                                </AvForm>
                              </div>
                            </Col>
                          </Row>
                          {loading ? (
                            <Spinner
                              color="secondary"
                              className="d-block m-auto"
                            />
                          ) : (
                            <>
                              {AllEarnings?.total === 0 ? (
                                <p className="my-2 mx-3 ">No Rewards!</p>
                              ) : (
                                <Row>
                                  <p>Total :&nbsp;{AllEarnings?.total} </p>

                                  <Col xl="12">
                                    <div className="table-responsive">
                                      <BootstrapTable
                                        // keyField={"id"}
                                        key={"id"}
                                        responsive
                                        bordered={false}
                                        striped={false}
                                        // defaultSorted={defaultSorted}
                                        // selectRow={selectRow}
                                        classes={
                                          "table align-middle table-nowrap"
                                        }
                                        headerWrapperClasses={"thead-light"}
                                        {...toolkitProps.baseProps}
                                        onTableChange={handleTableChange}
                                      />
                                    </div>
                                  </Col>
                                </Row>
                              )}
                              <MyPagination
                                totalPages={pages}
                                page={page}
                                setPage={setPage}
                              />
                            </>
                          )}
                        </React.Fragment>
                      )}
                    </ToolkitProvider>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </div>
  )
}

export default AllEarnings
